import { useState } from "react";

import * as inputValidation from "../../../utils/inputValidationUtils";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDatePickerNative from "../../Common/Forms/FromToDatePickerNative";

const handleEventChange = (e, handleChange) => {
  handleChange(e.target.name, e.target.value);
};

const isValid = (antallIleggelserPerIleggelsetypeFilterForm, handleChange) => {
  return (
    inputValidation.fraDateTimeTilDateTimeValidation(
      antallIleggelserPerIleggelsetypeFilterForm,
      handleChange,
    ) &&
    inputValidation.fromDateToDateRequiredValidation(
      antallIleggelserPerIleggelsetypeFilterForm.fraDato,
      antallIleggelserPerIleggelsetypeFilterForm.tilDato,
      handleChange,
    )
  );
};

const handleSubmit = (
  e,
  antallIleggelserPerIleggelsetypeFilterForm,
  handleChange,
  handleChangeAll,
  getAntallIleggelserPerIleggelsetype,
  setShowSokSpinner,
) => {
  e.preventDefault();
  if (isValid(antallIleggelserPerIleggelsetypeFilterForm, handleChange)) {
    handleChangeAll(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_SUBMITTED_FORM",
      {
        fraDato: antallIleggelserPerIleggelsetypeFilterForm.fraDato,
        tilDato: antallIleggelserPerIleggelsetypeFilterForm.tilDato,
        submitTimestamp: new Date(),
      },
    );
    setShowSokSpinner(true);
    getAntallIleggelserPerIleggelsetype({
      fraDato: antallIleggelserPerIleggelsetypeFilterForm.fraDato,
      tilDato: antallIleggelserPerIleggelsetypeFilterForm.tilDato,
    })
      .then(() => setShowSokSpinner(false))
      .catch(() => setShowSokSpinner(false));
  }
};

const AntallIleggelserPerIleggelsetypeFilterForm = ({
  antallIleggelserPerIleggelsetypeFilterForm,
  handleChange,
  handleChangeAll,
  handleChangeToInitState,
  getAntallIleggelserPerIleggelsetype,
}) => {
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  return (
    <form
      className="rapportSearch SearchHistorikkForm no-print"
      onSubmit={(e) =>
        handleSubmit(
          e,
          antallIleggelserPerIleggelsetypeFilterForm,
          handleChange,
          handleChangeAll,
          getAntallIleggelserPerIleggelsetype,
          setShowSokSpinner,
        )
      }
    >
      <div className="searchHistorikkOverskrift">
        Søk etter antall ileggelser per ileggelsetype
      </div>
      <div className="filter-flexbox-container ventilstilling-filter-flexbox">
        <FromToDatePickerNative
          fra={{
            id: "fraDato",
            name: "fraDato",
            label: "Dato fra",
            placeholder: "Velg dato",
            value: antallIleggelserPerIleggelsetypeFilterForm.fraDato,
            validationError:
              antallIleggelserPerIleggelsetypeFilterForm.fraDatoValidationErrorText,
          }}
          til={{
            id: "tilDato",
            name: "tilDato",
            label: "Dato til",
            placeholder: "Velg dato",
            value: antallIleggelserPerIleggelsetypeFilterForm.tilDato,
            validationError:
              antallIleggelserPerIleggelsetypeFilterForm.tilDatoValidationErrorText,
          }}
          onChange={(e) => handleEventChange(e, handleChange)}
        />
      </div>
      <div style={{ marginTop: 10 }}>
        <FormButtonsForCloseAndSubmit
          closeText="Tilbakestill"
          submitText="Søk"
          onClose={() =>
            handleChangeToInitState(
              "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_FILTER_FORM",
            )
          }
          onSubmit={() => {}}
          showCloseSpinner={false}
          showSubmitSpinner={showSokSpinner}
        />
      </div>
    </form>
  );
};

export default AntallIleggelserPerIleggelsetypeFilterForm;
